import axios from "axios";
import { EventEmitter } from "eventemitter3";

export default class PrepareService extends EventEmitter {
  constructor(url, headers) {
    super();
    this.url = url;
    this.headers = headers || {};
  }

  execute(name, pathList, pid, md5, size, behavior, cancelToken) {
    const data = {
      md5: md5,
      size: size,
      parentId: pid,
      fileName: name,
      pathList: pathList,
      conflictBehavior: behavior || "RENAME",
    };
    const { url, headers } = this;
    axios
      .post(url, data, { headers, cancelToken, timeout: 5000})
      .then((e) => {
        const { status, data } = e;
        if (data.code !== 200) {
          return this.emit("error", data.message);
        }
        const result = {
          ...data.data,
          fastUpload: status === 200,
        };
        this.emit("complete", result);
      })
      .catch((err) => {
        if (axios.isCancel(err)) {
          return this.emit("abort");
        }
        if (axios.isAxiosError(err)) {
          if (err.response) {
            // 请求已发出，但服务器响应的状态码不在 2xx 范围内
            this.emit("error", err.response.data);
          } else if (err.request) {
            // 请求已发出，但没有收到响应
            this.emit("error", err.request);
          } else {
            // 发生了一些其他错误
            this.emit("error", err);
          }
        } else {
          // 这是一个非 Axios 错误
          this.emit("error", err);
        }
      });
  }
}
